import * as React from "react";
import { Button} from "antd";
import { connect } from "react-redux";

interface IModifyProps {
  label: any;
  style: any;
  modifyReadonly:any;
}

// 修改
class Modify extends React.Component<IModifyProps, any> {
  constructor(props: IModifyProps) {
    super(props);
  }
  modifyReadonly = () => {
     
  };

  render() {
    return (
      <Button type="primary" onClick={this.props.modifyReadonly} key={this.props.label} style={{...this.props.style, paddingLeft: "28",paddingRight: "28", backgroundColor: "#2b9fbd" }} >
      <div>{this.props.label}</div>
      </Button>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    modifyReadonly: dispatch.orderDetails.modifyReadonly
  };
};

export default connect(
  null,
  mapDispatch
)(Modify);
